import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconChecklistSvg } from "./IconChecklistSvg.mjs";
const IconChecklist = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconChecklistSvg, ...svgProps }) });
export {
  IconChecklist
};
